import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaWhatsapp, FaCalendarAlt, FaHospital, FaInstagram } from 'react-icons/fa';
import { motion } from 'framer-motion';
import * as S from './Contact.styles';

const Contact: React.FC = () => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulación de envío del formulario
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitMessage('¡Gracias por tu mensaje! Te contactaremos pronto.');
      setFormData({ name: '', email: '', phone: '', message: '' });
      
      setTimeout(() => {
        setSubmitMessage('');
      }, 5000);
    }, 2000);
  };
  /* eslint-enable @typescript-eslint/no-unused-vars */

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, me gustaría agendar una consulta médica.');
    window.open(`https://wa.me/+56992247167?text=${message}`, '_blank');
  };

  return (
    <S.ContactSection id="contacto">
      <S.Container>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <S.SectionTitle as="h2">Contacto</S.SectionTitle>
          <S.SectionSubtitle>
            Agenda tu consulta y comienza tu camino hacia una mejor salud
          </S.SectionSubtitle>
        </motion.div>

        <S.ContentGrid style={{ gridTemplateColumns: '1fr' }}>
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <S.ContactInfo>
              <S.InfoTitle as="h3">Información de Contacto</S.InfoTitle>
              
              <S.InfoItem>
                <S.InfoIcon>
                  <FaPhone />
                </S.InfoIcon>
                <S.InfoContent>
                  <S.InfoLabel>Teléfono</S.InfoLabel>
                  <S.InfoValue>+56 9 9224 7167</S.InfoValue>
                </S.InfoContent>
              </S.InfoItem>

              <S.InfoItem>
                <S.InfoIcon>
                  <FaEnvelope />
                </S.InfoIcon>
                <S.InfoContent>
                  <S.InfoLabel>Email</S.InfoLabel>
                  <S.InfoValue>
                    <a href="mailto:dra.suni.chipanaflores@gmail.com">dra.suni.chipanaflores@gmail.com</a>
                  </S.InfoValue>
                </S.InfoContent>
              </S.InfoItem>

              <S.InfoItem>
                <S.InfoIcon>
                  <FaMapMarkerAlt />
                </S.InfoIcon>
                <S.InfoContent>
                  <S.InfoLabel>Ubicación</S.InfoLabel>
                  <S.InfoValue>Santiago de Chile</S.InfoValue>
                </S.InfoContent>
              </S.InfoItem>

              <S.InfoItem>
                <S.InfoIcon>
                  <FaClock />
                </S.InfoIcon>
                <S.InfoContent>
                  <S.InfoLabel>Horarios de Atención</S.InfoLabel>
                  <S.InfoValue>Lunes a Viernes: 9:00 - 18:00</S.InfoValue>
                </S.InfoContent>
              </S.InfoItem>

              <S.InfoItem>
                <S.InfoIcon>
                  <FaCalendarAlt />
                </S.InfoIcon>
                <S.InfoContent>
                  <S.InfoLabel>Agendamiento Online</S.InfoLabel>
                  <S.InfoValue>
                    <a href="https://encuadrado.com/p/suni-chipana-flores/" target="_blank" rel="noopener noreferrer">
                      Reserva tu hora en Encuadrado
                    </a>
                  </S.InfoValue>
                </S.InfoContent>
              </S.InfoItem>

              <S.InfoItem>
                <S.InfoIcon>
                  <FaHospital />
                </S.InfoIcon>
                <S.InfoContent>
                  <S.InfoLabel>Clínica IntegraMédica</S.InfoLabel>
                  <S.InfoValue>
                    <a href="https://agenda.bupa.cl/integramedica/telemedicina/reserva-telemedicina" target="_blank" rel="noopener noreferrer">
                      Reserva tu hora en Bupa IntegraMédica
                    </a>
                    <br />
                    <span style={{ fontSize: '0.95em', color: '#64748b' }}>
                      (Medicina general, Chipana Flores Suni Wiphala)
                    </span>
                  </S.InfoValue>
                </S.InfoContent>
              </S.InfoItem>

              <S.InfoItem>
                <S.InfoIcon>
                  <FaInstagram />
                </S.InfoIcon>
                <S.InfoContent>
                  <S.InfoLabel>Instagram</S.InfoLabel>
                  <S.InfoValue>
                    <a href="https://instagram.com/dra_suni" target="_blank" rel="noopener noreferrer">
                      @dra_suni
                    </a>
                  </S.InfoValue>
                </S.InfoContent>
              </S.InfoItem>

              <S.WhatsAppButton onClick={handleWhatsAppClick}>
                <FaWhatsapp />
                Contactar por WhatsApp
              </S.WhatsAppButton>
            </S.ContactInfo>
          </motion.div>
        </S.ContentGrid>
      </S.Container>
    </S.ContactSection>
  );
};

export default Contact;